document.addEventListener("DOMContentLoaded", () => {
    const isAddressThemeV1 = document.body.classList.contains('address-theme--v1');
    if (isAddressThemeV1) {

        let speedTest = new Checkspeed(); //create check-speed object
        speedTest.setParameter("telemetry_level", "basic"); //enable telemetry

        let meterBk = "#D8D9E3",
            dlColor = "#1BAF89",
            ulColor = "#F9724A",
            progColor = meterBk;

        //CODE FOR GAUGES
        function drawMeter(c, amount, bk, fg, progress, prog) {

            var ctx = c.getContext("2d");
            var dp = window.devicePixelRatio || 1;
            var cw = c.clientWidth * dp,
                ch = c.clientHeight * dp;
            var sizScale = ch * 0.0055;
            if (c.width == cw && c.height == ch) {
                ctx.clearRect(0, 0, cw, ch);
            } else {
                c.width = cw;
                c.height = ch;
            }


            let gradient = ctx.createLinearGradient(0, 0, 170, 0)
            if (fg == 'dlColor') {
                gradient.addColorStop('0', '#4AA2BA')
                gradient.addColorStop('1.0', '#1BAF89')
            } else {
                gradient.addColorStop('0', '#F9B369')
                gradient.addColorStop('1.0', '#F9724A')
            }

            ctx.clearRect(0, 0, cw, ch);
            ctx.beginPath();
            ctx.strokeStyle = bk;
            ctx.lineWidth = 18 * sizScale;
            ctx.arc(c.width / 2, c.height - 58 * sizScale, c.height / 1.8 - ctx.lineWidth, -Math.PI * 1.1, Math.PI * 0.1);
            ctx.stroke();
            ctx.beginPath();
            ctx.strokeStyle = gradient;
            ctx.lineWidth = 18 * sizScale;
            ctx.arc(c.width / 2, c.height - 58 * sizScale, c.height / 1.8 - ctx.lineWidth, -Math.PI * 1.1, amount * Math
                .PI * 1.2 - Math.PI * 1.1);
            ctx.stroke();


            // if (typeof progress !== "undefined") {
            //     ctx.fillStyle = prog;
            //     ctx.fillRect(0, 0, c.width * 0.4 * progress, 4 * sizScale);
            // }
        }

        function mbpsToAmount(s) {
            return 1 - (1 / (Math.pow(1.3, Math.sqrt(s))));
        }

        function format(d) {
            d = Number(d);
            if (d < 10) return d.toFixed(2);
            if (d < 100) return d.toFixed(1);
            return d.toFixed(0);
        }

//UI CODE
        let uiData = null;

        function startStop() {
            if (speedTest.getState() == 3) {
                //check speed is running, abort
                speedTest.abort();
                data = null;
                document.getElementById("startStopBtn").className = "btn size-60";
                initUI();
            } else {
                //test is not running, begin
                const startBtnWrapper = document.querySelector(".pulse-cta");
                const resultElements = document.querySelectorAll(".check-speed__row");

                startBtnWrapper.classList.remove("active");
                resultElements.forEach(el => {
                    el.classList.add("active");
                })

                initSpeedTest();

                const resultBlock = document.getElementById("check-speed__result");
                if (resultBlock) resultBlock.className = "check-speed__result hide";
                speedTest.onupdate = function (data) {
                    uiData = data;
                };
                speedTest.onend = function (aborted) {
                    document.querySelector('.check-speed__buttons').classList.add("active");
                    updateUI(true);
                };
                speedTest.start();
            }
        }

        function frame() {
            requestAnimationFrame(frame);
            updateUI();
        }

        function initUI() {
            drawMeter(document.getElementById("dlMeter"), 0, meterBk, dlColor, 0);
            drawMeter(document.getElementById("ulMeter"), 0, meterBk, ulColor, 0);
            document.getElementById("dlText").textContent = "";
            document.getElementById("ulText").textContent = "";
            document.querySelector(".check-speed-info__value.provider").textContent = "";
            document.querySelector(".check-speed-info__value.ip").textContent = "";
        }

        function initSpeedTest() {
            frame();

            setTimeout(function () {
                initUI()
            }, 100);
        }

        //this function reads the data sent back by the test and updates the UI
        function updateUI(forced) {
            if (!forced && speedTest.getState() != 3) return;
            if (uiData == null) return;
            let status = uiData.testState;
            const parts = uiData.clientIp.split(" - ");
            document.querySelector(".check-speed-info__value.ip").textContent = parts[0];
            document.querySelector(".check-speed-info__value.provider").textContent = parts[1];

            document.getElementById("dlText").textContent = (status == 1 && uiData.dlStatus == 0) ? "..." : format(uiData.dlStatus);
            drawMeter(
                document.getElementById("dlMeter"),
                mbpsToAmount(Number(uiData.dlStatus * (status == 1 ? oscillate() : 1))),
                meterBk,
                'dlColor',
                Number(uiData.dlProgress),
                progColor
            );
            document.getElementById("ulText").textContent = (status == 3 && uiData.ulStatus == 0) ? "..." : format(uiData.ulStatus);
            drawMeter(
                document.getElementById("ulMeter"),
                mbpsToAmount(Number(uiData.ulStatus * (status == 3 ? oscillate() : 1))),
                meterBk,
                'ulColor',
                Number(uiData.ulProgress),
                progColor
            );
        }

        function oscillate() {
            return 1 + 0.02 * Math.sin(Date.now() / 100);
        }

        //update the UI every frame
        window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window
            .mozRequestAnimationFrame || window.msRequestAnimationFrame || (function (callback, element) {
            setTimeout(callback, 1000 / 60);
        });

        const startStopBtns = document.querySelectorAll(".startStopBtn");
        startStopBtns.forEach((btn) => {
            btn.addEventListener("click", startStop);
        })
    }
});
